// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"1a8633dc","215":"93c94309","361":"99b5d831","787":"77f29b5b"}[chunkId] + ".chunk.js";
};